import { useReducer } from 'react'
import type { GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { globalSearchStateReducer, GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'

export default function useGlobalSearchContext(initialState: GlobalSearchState = GLOBAL_SEARCH_INITIAL_STATE) {
  const [globalSearchState, globalSearchDispatch] = useReducer<GlobalSearchState, [GlobalSearchAction]>(globalSearchStateReducer, initialState)

  return { globalSearchState, globalSearchDispatch }
}
